var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationDeniedPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1562 70.9535C66.0606 70.9535 70.0365 66.9778 70.0365 62.0734C70.0365 57.1691 66.0606 53.1934 61.1562 53.1934C56.2517 53.1934 52.2759 57.1691 52.2759 62.0734C52.2759 66.9778 56.2517 70.9535 61.1562 70.9535Z",
    stroke: "#DA867D",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7236 29.04V32.5921C48.7236 34.5537 50.3141 36.1441 52.2758 36.1441H59.38",
    stroke: "#1E247E",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.871 70.954H34.515C32.5534 70.954 30.9629 69.3635 30.9629 67.4019V32.5921C30.9629 30.6305 32.5534 29.04 34.515 29.04H52.2756C56.1989 29.04 59.3799 32.2209 59.3799 36.1441V46.1875",
    stroke: "#1E247E",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.435 68.3531L54.8765 55.7949",
    stroke: "#DA867D",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0669 46.0923H52.2754",
    stroke: "#F0C330",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0669 53.1934H46.9472",
    stroke: "#F0C330",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0669 60.2944H45.1711",
    stroke: "#F0C330",
    strokeWidth: 2.6391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationDeniedPageIcon);
export default __webpack_public_path__ + "static/media/ApplicationDeniedPageIcon.821bee9885edb04ac7cb4f1c6d946ef4.svg";
export { ForwardRef as ReactComponent };